var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 8.00156,
    cy: 7.99961,
    r: 6.4,
    fill: "url(#paint0_linear_9735_243080)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93169 9.13253L8.79313 7.99461L9.93105 6.85669C10.1499 6.63845 10.1499 6.28325 9.93105 6.06501C9.71217 5.84485 9.35825 5.84549 9.13937 6.06437L8.00081 7.20229L6.86225 6.06309C6.64337 5.84421 6.28881 5.84549 6.06993 6.06309C5.85169 6.28197 5.85169 6.63717 6.06993 6.85541L7.20913 7.99461L6.07249 9.13061C5.85361 9.34949 5.85361 9.70469 6.07249 9.92229C6.18193 10.0324 6.32465 10.0868 6.46801 10.0868C6.61201 10.0868 6.75473 10.0324 6.86417 9.92293L8.00081 8.78629L9.14001 9.92485C9.24945 10.0343 9.39217 10.0887 9.53553 10.0887C9.67889 10.0887 9.82225 10.0337 9.93169 9.92485C10.1506 9.70597 10.1506 9.35141 9.93169 9.13253Z",
    fill: "url(#paint1_linear_9735_243080)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9735_243080",
    x1: 1.60156,
    y1: 1.59961,
    x2: 1.60156,
    y2: 14.3996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9735_243080",
    x1: 5.90625,
    y1: 5.89941,
    x2: 5.90625,
    y2: 10.0887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D01400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/Failed.deb098686b63b23bca95e7c44aeb1bd9.svg";
export { ForwardRef as ReactComponent };